import "../styles/fonts.scss";
import "../styles/index.scss";
import "../styles/about.scss";
import "../styles/privacy-policy.scss";

$(window).load(function() {
  try {
    require("./main");
  } catch (e) {
    $("body").addClass("unsupported");
  }

  $("body").addClass("ready");
});
